import { holdTaskEntryOf } from '../constants/holdTaskCatalog';

/**
 * Where a hold task is fixed, as its catalog entry says: the same record and section a held item of
 * that reason opens, so the worklist and the billing items list send a biller to one place.
 *
 * @param {import('../model/HoldTask.types').HoldTask} hold
 * @returns {{kind: string, recordId: string, section: string|null}|null}
 */
// eslint-disable-next-line import/prefer-default-export
export function fixForHoldTask(hold) {
  const fix = holdTaskEntryOf(hold?.holdType)?.fix;
  const recordId = fix?.on === 'clinic' ? hold.clinicId : hold?.subjectId;

  return fix && recordId ? { kind: fix.kind, recordId, section: fix.section ?? null } : null;
} // fixForHoldTask()
